import axios from 'axios';

const SERVER = (process.env.REACT_APP_SERVER || '').replace(/\/$/, '');
const SIGNUP_TOKEN_KEY = 'garam-naver-signup-token';

// 네이버 신규 가입용 임시 토큰을 새로고침에도 유지되도록 저장한다.
export function saveSignupToken(token) {
    sessionStorage.setItem(SIGNUP_TOKEN_KEY, token);
}

// 저장된 네이버 신규 가입용 임시 토큰을 읽는다.
export function readSignupToken() {
    try {
        return sessionStorage.getItem(SIGNUP_TOKEN_KEY) || '';
    } catch {
        return '';
    }
}

// 가입이 끝나거나 취소되면 임시 토큰을 지운다.
export function clearSignupToken() {
    sessionStorage.removeItem(SIGNUP_TOKEN_KEY);
}

// 네이버 성별 값(M/F, male/female)을 가입 폼 값으로 바꾼다.
function normalizeGender(value) {
    const gender = String(value || '').toLowerCase();
    if (gender === 'm' || gender === 'male') return 'male';
    if (gender === 'f' || gender === 'female') return 'female';
    return '';
}

// birthDate 또는 birthyear + birthday(MM-DD / MMDD)로 YYYY-MM-DD를 만든다. 불완전하면 ''.
function normalizeBirthDate(source) {
    if (/^\d{4}-\d{2}-\d{2}$/.test(source.birthDate || '')) return source.birthDate;
    const year = String(source.birthyear || source.birthYear || '');
    const day = String(source.birthday || '').replace(/\D/g, '');
    return /^\d{4}$/.test(year) && /^\d{4}$/.test(day) ? `${year}-${day.slice(0, 2)}-${day.slice(2)}` : '';
}

// 프리필 응답에서 네이버가 제공한 이름·이메일·성별·생년월일만 추린다.
export function toNaverPrefill(data) {
    const source = data?.profile || data?.user || data || {};
    return {
        email: typeof source.email === 'string' ? source.email : '',
        name: typeof source.name === 'string' ? source.name.trim() : '',
        gender: normalizeGender(source.gender),
        birthDate: normalizeBirthDate(source),
    };
}

// 임시 토큰으로 네이버에서 받은 가입 정보를 조회한다.
export async function fetchNaverSignup(token) {
    const { data } = await axios.get(`${SERVER}/api/auth/naver/signup`, { params: { token }, withCredentials: true, timeout: 45000 });
    return toNaverPrefill(data);
}

// 약관 동의와 부족한 정보를 보내 네이버 계정으로 가입한다.
export async function registerNaver(body) {
    const { data } = await axios.post(`${SERVER}/api/auth/naver/register`, body, { withCredentials: true, timeout: 45000 });
    return data;
}
